import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-bon-de-sorite',
  templateUrl: './document-bon-de-sorite.component.html',
  styleUrls: ['./document-bon-de-sorite.component.scss']
})
export class DocumentBonDeSoriteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
